<template>
    <div class="border border-a-gray-d8d8d8 rounded-5 bg-white">
        <iframe title="" :src="config" border="0" width="100%" height="200"></iframe>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        config: {
            type: String
        }
    },
    setup: function () {

    }
})
</script>


